class SectionVerticalTextVideo implements ng.IComponentController {
    ltTitle: string;
    description: string;
    isPlayBtn: boolean;
    isDuration: boolean;
    bgStyle: anm.WaveBackground;
    video: anm.LandingVideo;
    buttons: anm.LandingButtonData[];

    constructor() {
        this.bgStyle = this.bgStyle || 'gradient-wave';
    }
}

angular.module('animatronApp.sectionVerticalTextVideo', []).component('sectionVerticalTextVideo', {
    bindings: {
        ltTitle: '<',
        description: '<',
        isDuration: '<?',
        buttons: '<',
        video: '<',
        isPlayBtn: '<',
        bgStyle: '@',
    },
    controller: SectionVerticalTextVideo,
    templateUrl: require('landing-template/components/sections/section-vertical-text-video.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVerticalTextVideo.ts